import { getField, updateField } from 'vuex-map-fields'
import { cloneDeep } from 'lodash'
import BeltChange from '../models/beltChange/beltChange'
import AxiosAdapter from '../models/beltChange/axiosAdapter'
import ApiGateway from '../models/beltChange/apiGateway'

const calculateActivityTypesFilterOptions = athleteActivities => {
  const typesFromActivities = new Set(athleteActivities.map(a => a.type))
  return ['all', ...typesFromActivities]
}

const defaultState = {
  athleteActivities: [],
  activityTypeSelectedFilter: 'all',
  activityTypesFilterOptions: [],
  error: null
}

export const state = () => cloneDeep(defaultState)

export const getters = {
  getField,
  athleteActivities(state) {
    if (state.activityTypeSelectedFilter === 'all') {
      return state.athleteActivities
    } else {
      return state.athleteActivities.filter(a => a.type === state.activityTypeSelectedFilter)
    }
  }
}

export const mutations = {
  updateField,
  reset(state) {
    Object.assign(state, defaultState)
  },
  activityTypesFilterOptions(state, filterOptions) {
    state.activityTypesFilterOptions = filterOptions
  }
}

export const actions = {
  async fetchAthleteActivities({ commit }, athleteId) {
    try {
      // Clean athleteActivities before fetching new data.
      commit('updateField', { path: 'athleteActivities', value: [] })

      const apiGateway = new ApiGateway(new AxiosAdapter(this.$coreApi))
      const athleteActivities = await BeltChange.listAthleteActivities(apiGateway, athleteId)

      commit('updateField', { path: 'error', value: null })
      commit('updateField', { path: 'athleteActivities', value: athleteActivities })
      commit('activityTypesFilterOptions', calculateActivityTypesFilterOptions(athleteActivities))
    } catch (error) {
      if (error.response) {
        commit('updateField', { path: 'error', value: error.response })
        return
      }

      throw error
    }
  },

  reset({ commit }) {
    commit('updateField', { path: 'error', value: null })
    commit('reset')
  }
}
